import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FuseConfig, FuseConfigService } from '@fuse/services/config';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-auth-redirect',
  templateUrl: './auth-redirect.component.html',
  styleUrls: ['./auth-redirect.component.scss']
})
export class AuthRedirectComponent implements OnInit {


  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _userService: UserService,
    private _fuseConfigService: FuseConfigService,
  ) {
  }

  /**
   * On init
   */
  ngOnInit(): void {

    const redirectURL = '/member/home';
    // Navigate to the redirect url
    this._router.navigateByUrl(redirectURL);
    // Subscribe to user changes
    // this._userService.user$
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe((user: User) => {
      

    //     const redirectURL = '/member/home';

    //     // Navigate to the redirect url
    //     this._router.navigateByUrl(redirectURL);
        
    //     this._unsubscribeAll.next(null);
    //     this._unsubscribeAll.complete();

    //     // Mark for check
    //     this._changeDetectorRef.markForCheck();
    //   });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
